export const container = {
    color: 'primary.main',
    border: 2,
    borderColor: 'error.main',
    padding: 2,
    lineHeight: '24px',
};
const content = {
    display: 'flex',
};
const text = {
    lineHeight: '24px',
    color: 'secondary.dark',
    marginLeft: 1,
};
export const errorMsg = {
    display: 'flex',
    color: 'error.main',
    my: 1,
};
export default {
    container,
    content,
    errorMsg,
    text,
};
